import { useMemo } from 'react';
import useAuthUser from './useAuthUser';
import {
  adminNavigation,
  agentNavigation,
  merchantNavigation,
  processorNavigation,
  managerNavigation,
} from 'app/configs/navigationConfig';

function useUserNavigation() {
  const user = useAuthUser();
  return useMemo(() => {
    if (user?.role === 'agent') return agentNavigation;

    if (user?.role === 'admin') return adminNavigation;

    if (user?.role === 'manager') return managerNavigation;

    if (user?.role === 'processor') return processorNavigation;
    return merchantNavigation;
  }, [user?.role]);
}

export default useUserNavigation;
